<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading">
    <div class="flex flex-row items-center gap-5 font-semibold text[#424242] dark:text-white mb-8 mx-5 cursor-pointer">
        <p (click)="navigateToCollectionReports()">Reports</p>
        <p onclick="history.back()">Collection Reports</p>
        <p>Farmer Invoice Report</p>
    </div>


    <div class="w-full px-10 py-7 bg-tileLight  shadow-lg rounded-lg mt-6 dark:bg-[#363636]">
        <div id="reportContainer">
            <div>
                <p class="font-semibold dark:text-white mb-1">INV NO : {{userObj.invNo}}</p>
                <p class="dark:text-textDark text-[#575757]">
                    Date : {{ userObj.createdAt | date:'yyyy/MM/dd At hh:mm a' }}
                </p>
            </div>

            <div class="mt-6 mb-4">
                <p class=" mb-3 dark:text-textDark font-semibold">Personal Details</p>
                <table>
                    <thead>
                        <tr>
                            <th
                                class="text-[#434343] border-[2px] border-[#b3b1b1] text-center py-2 px-8 dark:text-white">
                                First Name
                            </th>
                            <th
                                class="text-[#434343] border-[2px] border-[#b3b1b1] text-center py-2 px-8 dark:text-white">
                                Last Name
                            </th>
                            <th
                                class="text-[#434343] border-[2px] border-[#b3b1b1] text-center py-2 px-8 dark:text-white">
                                NIC Number
                            </th>
                            <th
                                class="text-[#434343] border-[2px] border-[#b3b1b1] text-center py-2 px-8 dark:text-white">
                                Phone Number
                            </th>
                            <th
                                class="text-[#434343] border-[2px] border-[#b3b1b1] text-center py-2 px-8 dark:text-white">
                                Address</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td
                                class="border-[2px] border-[#b3b1b1] text-[#000000] text-center py-2 px-8 dark:text-textDark">
                                {{userObj.firstName}}</td>
                            <td
                                class="border-[2px] border-[#b3b1b1] text-[#000000]text-center py-2 px-8 dark:text-textDark">
                                {{userObj.lastName}}</td>
                            <td
                                class="border-[2px] border-[#b3b1b1] text-[#000000] text-center py-2 px-8 dark:text-textDark">
                                {{userObj.NICnumber}}</td>
                            <td
                                class="border-[2px] border-[#b3b1b1] text-[#000000] text-center py-2 px-8 dark:text-textDark">
                                {{userObj.phoneNumber}}</td>
                            <td
                                class="border-[2px] border-[#b3b1b1] text-[#000000] text-center py-2 px-8 dark:text-textDark">
                                <span *ngIf="userObj.houseNo && userObj.streetName && userObj.city; else noAddress">
                                    {{ userObj.houseNo }}, {{ userObj.streetName }}, {{ userObj.city }}
                                </span>
                                <ng-template #noAddress>
                                    <span> - </span>
                                </ng-template>
                            </td>

                        </tr>
                    </tbody>
                </table>


            </div>


            <div class="mt-10 mb-4">
                <p class="dark:text-textDark font-semibold mb-3">Bank Details</p>
                <table>
                    <thead>
                        <tr>
                            <th
                                class="border-[2px] border-[#b3b1b1] text-[#434343] text-center py-2 px-8 dark:text-white">
                                Account
                                Number
                            </th>
                            <th
                                class="border-[2px] border-[#b3b1b1] text-[#434343] text-center py-2 px-8 dark:text-white">
                                Account
                                Holder’s
                                Name</th>
                            <th
                                class="border-[2px] border-[#b3b1b1] text-[#434343] text-center py-2 px-8 dark:text-white">
                                Bank Name
                            </th>
                            <th
                                class="border-[2px] border-[#b3b1b1] text-[#434343] text-center py-2 px-8 dark:text-white">
                                Branch Name
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <td
                            class="border-[2px] border-[#b3b1b1] text-[#000000] text-center py-2 px-8 dark:text-textDark">
                            {{userObj.accNumber}}</td>
                        <td
                            class="border-[2px] border-[#b3b1b1] text-[#000000] text-center py-2 px-8 dark:text-textDark">
                            {{userObj.accHolderName}}</td>
                        <td
                            class="border-[2px] border-[#b3b1b1] text-[#000000] text-center py-2 px-8 dark:text-textDark">
                            {{userObj.bankName}}</td>
                        <td
                            class="border-[2px] border-[#b3b1b1] text-[#000000] text-center py-2 px-8 dark:text-textDark">
                            {{userObj.branchName}}</td>
                    </tbody>
                </table>

            </div>


            <div class="mt-10">
                <p class="dark:text-textDark font-semibold mb-3">Crop Details</p>
                <table>
                    <thead>
                        <tr>
                            <th
                                class="border-[2px] border-[#b3b1b1] text-[#434343] text-center py-2 px-4 dark:text-white text-[14px]">
                                Crop Name
                            </th>
                            <th
                                class="border-[2px] border-[#b3b1b1] text-[#434343] text-center py-2 px-4 dark:text-white text-[14px]">
                                Variety</th>
                            <th
                                class="border-[2px] border-[#b3b1b1] text-[#434343] text-center py-2 px-4 dark:text-white text-[14px]">
                                Unit Price
                                (A)
                            </th>
                            <th
                                class="border-[2px] border-[#b3b1b1] text-[#434343] text-center py-2 px-4 dark:text-white text-[14px]">
                                Quantity
                            </th>
                            <th
                                class="border-[2px] border-[#b3b1b1] text-[#434343] text-center py-2 px-4 dark:text-white text-[14px]">
                                Unit Price
                                (B)
                            </th>
                            <th
                                class="border-[2px] border-[#b3b1b1] text-[#434343] text-center py-2 px-4 dark:text-white text-[14px]">
                                Quantity
                            </th>
                            <th
                                class="border-[2px] border-[#b3b1b1] text-[#434343] text-center py-2 px-4 dark:text-white text-[14px]">
                                Unit Price
                                (C)
                            </th>
                            <th
                                class="border-[2px] border-[#b3b1b1] text-[#434343] text-center py-2 px-4 dark:text-white text-[14px]">
                                Quantity
                            </th>
                            <th
                                class="border-[2px] border-[#b3b1b1] text-[#434343] text-center py-2 px-4 dark:text-white text-[14px]">
                                Total (Rs.)</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of CropArr">
                            <td
                                class="border-[2px] border-[#b3b1b1] text-[#000000] text-center py-2 px-4 dark:text-textDark text-[14px]">
                                {{item.cropNameEnglish}}</td>
                            <td
                                class="border-[2px] border-[#b3b1b1] text-[#000000] text-center py-2 px-4 dark:text-textDark text-[14px]">
                                {{item.varietyNameEnglish}}</td>
                            <td
                                class="border-[2px] border-[#b3b1b1] text-[#000000] text-center py-2 px-4 dark:text-textDark text-[14px]">
                                {{item.gradeAprice}}</td>
                            <td
                                class="border-[2px] border-[#b3b1b1] text-[#000000] text-center py-2 px-4 dark:text-textDark text-[14px]">
                                {{(item.gradeAquan | number: '1.2-2' )}}</td>
                            <td
                                class="border-[2px] border-[#b3b1b1] text-[#000000] text-center py-2 px-4 dark:text-textDark text-[14px]">
                                {{item.gradeBprice}}</td>
                            <td
                                class="border-[2px] border-[#b3b1b1] text-[#000000] text-center py-2 px-4 dark:text-textDark text-[14px]">
                                {{(item.gradeBquan | number: '1.2-2' )}}</td>
                            <td
                                class="border-[2px] border-[#b3b1b1] text-[#000000] text-center py-2 px-4 dark:text-textDark text-[14px]">
                                {{item.gradeCprice}}</td>
                            <td
                                class="border-[2px] border-[#b3b1b1] text-[#000000] text-center py-2 px-4 dark:text-textDark text-[14px]">
                                {{(item.gradeCquan | number: '1.2-2' )}}</td>
                            <td
                                class="border-[2px] border-[#b3b1b1] text-[#000000] text-center py-2 px-4 dark:text-textDark text-[14px]">

                                {{ calculateRowTotal(item) != null ? (calculateRowTotal(item) | number: '1.2-2') :
                                '0.00' }}
                            </td>

                        </tr>
                    </tbody>
                </table>
            </div>


            <p class="font-medium my-8 text-[#000000] dark:text-white">
                Full Total (Rs.) :
                <span class="dark:text-textDark">
                    {{ totalAmount != null ? (totalAmount | number: '1.2-2') : '0.00' }}
                </span>
            </p>

            <div class="flex flex-row items-center justify-center gap-[15%]">
                <div class="flex flex-col gap-2 items-center">
                    <ng-container *ngIf="userObj.farmerQr; else farmerPlaceholder">
                        <img class="w-36 h-auto" [src]="userObj.farmerQr" />
                    </ng-container>
                    <ng-template #farmerPlaceholder>
                        <div class="w-36 h-36"></div>
                    </ng-template>
                    <p class="text-[#000000] font-medium dark:text-textDark">Farmer’s QR Code</p>
                </div>

                <div class="flex flex-col gap-2 items-center">
                    <ng-container *ngIf="userObj.officerQr; else officerPlaceholder">
                        <img class="w-36 h-auto" [src]="userObj.officerQr" />
                    </ng-container>
                    <ng-template #officerPlaceholder>
                        <div class="w-36 h-36"></div>
                    </ng-template>
                    <p class=" text-[#000000] font-medium dark:text-textDark">Officer’s QR Code</p>
                </div>
            </div>

        </div>

        <div class="flex items-center justify-center mt-10">
            <button (click)="downloadReport()"
                class="bg-[#415CFF] text-[18px] text-white px-6 py-2 rounded-lg shadow-lg">
                Download
            </button>

        </div>
    </div>
</div>